import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import SuperviseUserPage from "@/components/supervise/supervise-user-page";
import { userIdSearchSchema } from "@/lib/search/user-id-search";

const SuperviseUserRoutePage = (): JSX.Element => {
	const { userId } = Route.useSearch();
	return <SuperviseUserPage userId={userId} />;
};

export const Route = createFileRoute("/_app/supervise/user/")({
	validateSearch: userIdSearchSchema,
	component: SuperviseUserRoutePage,
});
